import React from "react"
import { Navigate } from "react-router-dom"
import { useAuth } from "../../context/AuthContext"

const AdminRoute = ({ children }) => {
    const { isAuthenticated, loading, isAdmin } = useAuth()

    if (loading) {
        return (
            <div className="min-vh-100 d-flex justify-content-center align-items-center">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        )
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />
    }

    if (!isAdmin()) {
        return <Navigate to="/" replace />
    }

    return children
}

export default AdminRoute 